import { useState } from 'react';
export function useCheckbox(initialValue) {
    var _a = useState(initialValue), value = _a[0], setValue = _a[1];
    var _b = useState(undefined), error = _b[0], setError = _b[1];
    return {
        value: value,
        setValue: setValue,
        reset: function () { return setValue(false); },
        bind: {
            value: value,
            onChange: function (event) {
                setValue(event.target.checked);
            },
        },
        error: error,
        setError: setError,
    };
}
